import { FormGroup, FormArray } from '@angular/forms';

/**
 * WARNING: Add in array, and will overwrite original formControls Validator(s)
 * @param extraValidators new array of Validators in form of equal to the original formGroup
 * @param path optional parameter, because recursivity, no need to add initially
 */
export function setValidators(formGroup: FormGroup, extraValidators: any, path?: string): FormGroup {
    Object.keys(extraValidators).forEach(key => {
        const newPath = path ? path + '.' + key : key;
        if (Array.isArray(extraValidators[key])) {
            formGroup.get(newPath).setValidators(extraValidators[key]);
        } else {
            setValidators(formGroup, extraValidators[key], newPath);
        }
    });
    return formGroup;
}